export class OrderService {
    static openPopup(skus: string[]): void {
        if (!skus.length) return

        const skuString = skus.join(',')
        const btn = document.getElementById('btnBuyNow')

        if (btn) {
            btn.setAttribute('data-sku', skuString);
            console.log("Popup", skuString, btn)
        } else {
            //console.warn('btnBuyNow not found – Maven360 script missing?')
        }
    }

    static extractSkusFromArtikel(artikelList: any[]): string[] {
        return artikelList.map(a => a.pzn ?? a.PZN).filter(Boolean)
    }
}